import { StateCreator } from "zustand";

import { NavigationSliceType } from "@/state/@types";

export const createNavigationSlice: StateCreator<
  NavigationSliceType,
  [],
  [],
  NavigationSliceType
> = (set, get) => ({
  focusOriginStack: [],
  detailOriginCell: null,

  pushFocusOrigin: (origin) =>
    set((state) => ({
      focusOriginStack: [...state.focusOriginStack, origin],
    })),

  popFocusOrigin: () => {
    const stack = get().focusOriginStack;
    if (stack.length === 0) return;
    const popped = stack[stack.length - 1];
    set({ focusOriginStack: stack.slice(0, -1) });
    if (popped?.elementRef && document.contains(popped.elementRef)) {
      popped.elementRef.focus();
    }
  },

  clearFocusOriginStack: () => set({ focusOriginStack: [] }),
});
